export default __webpack_public_path__ + "static/media/ojoder.30f11791.png";